import React, { useEffect, useState } from 'react';
import AccordianDownIcon from '../../assets/AccordianDownIcon';
import AccordianUpIcon from '../../assets/AccordianUpIcon';
import ExclamatoryIcon from '../../assets/icon/Exclamatory';
import EditIcon from '../../assets/EditIcon';
import WeatherInfoCard from '../common/WeatherTravelDetails';
import { translate } from '../../i18n';
import WeatherForm from '../common/WeatherTravelForm';
import Accordion from '../../components/common/Accordian';
import { IForecastDetails } from '../../type/forecastDetails';
import { IForecastEntryOption } from '../../type/forecastEntryOption';
import AccordianDownIconDark from '../../assets/AccordianDownIconDark';
import AccordianUpIconDark from '../../assets/AccordianUpIconDark';
import EditIconDark from '../../assets/EditIconDark';
import {
  useForecastOptions,
  useTravelStatusDetails,
} from '../../hooks/apiHook/operationDetails';
import Loader from '../../assets/loader/Loader';

interface Props {
  bgColor: string;
  ownerId: number;
  selectedDate: Date;
}

const WeatherAndTravelStatus: React.FC<Props> = ({
  bgColor,
  ownerId,
  selectedDate,
}) => {
  const [weatherandTravelAccordionIsOpen, setweatherandTravelAccordionIsOpen] =
    useState<boolean | undefined>(false);
  const [forcastDetails, setForcastDetails] = useState<IForecastDetails[]>([]);
  const [forcastOptions, setForcastOptions] = useState<IForecastEntryOption>();
  const [selectedForcast, setSelectedForcast] = useState<IForecastDetails>();
  const [isEditOpen, setIsEditOpen] = useState(false);
  // const [loading, setLoading] = useState(false); // ✅ New loading state

  const {
    data: travelStatusData,
    isLoading: isTravelStatusLoading,
    refetch: refetchTravelStatus,
  } = useTravelStatusDetails(selectedDate, ownerId);

  const { data: forecastOptions, isLoading: isForecastOptionsLoading } =
    useForecastOptions();

  useEffect(() => {
    if (travelStatusData) {
      setForcastDetails(travelStatusData);
    }
  }, [travelStatusData]);

  useEffect(() => {
    if (forecastOptions) {
      setForcastOptions(forecastOptions);
    }
  }, [forecastOptions]);

  const handleEditClickWeather = (forecast: any) => {
    setSelectedForcast(forecast);
    setIsEditOpen(true);
  };

  const isMissingData = forcastDetails?.some((e) => e.isDataPresent === false);

  return (
    <>
      <Accordion
        title={translate('weatherAndTravel.weatherAndTravel')}
        iconOpen={
          <div>
            <div className="block dark:hidden">
              <AccordianDownIcon />
            </div>
            <div className="hidden dark:block">
              <AccordianDownIconDark />
            </div>
          </div>
        }
        iconClose={
          <div>
            <div className="block dark:hidden">
              <AccordianUpIcon />
            </div>
            <div className="hidden dark:block">
              <AccordianUpIconDark />
            </div>
          </div>
        }
        bgColor={`${bgColor}`}
        accordionIsOpen={weatherandTravelAccordionIsOpen}
        toggleState={setweatherandTravelAccordionIsOpen}
        icon={
          isMissingData ? <ExclamatoryIcon width={18} height={18} /> : undefined
        }
      >
        {isTravelStatusLoading ? (
          <div className="flex justify-center align-middle">
            <Loader/>
          </div>
        ) : forcastDetails && forcastDetails.length > 0 ? (
          forcastDetails.map((forcast, index) => (
            <Accordion
              key={index}
              title={forcast?.operationDate?.slice(0, 10)}
              icon={
                <div>
                  <div className="block dark:hidden cursor-pointer">
                    <EditIcon onClick={() => handleEditClickWeather(forcast)} />
                  </div>
                  <div className="hidden dark:block cursor-pointer">
                    <EditIconDark
                      onClick={() => handleEditClickWeather(forcast)}
                    />
                  </div>
                </div>
              }
              bgColor={`bg-backgroundColor-white`}
              isActive={true}
              isFlightCancelled={
                !forcast?.isDataPresent ? 'Information Missing' : ''
              }
            >
              <WeatherInfoCard
                key={index}
                data={{
                  heading: forcast?.headline,
                  expectedTemp: forcast?.expectedTemp,
                  ofl: forcast?.ofl,
                  forecastStatus: forcast?.forecastExpected,
                  information: forcast?.whatToBring,
                  note: forcast?.note,
                  lastUpdated: forcast?.lastUpdated,
                }}
              />
            </Accordion>
          ))
        ) : (
          <div className="text-center text-gray-500 p-4">
            {translate('operation.dataIsNotAvailable')}
          </div>
        )}
      </Accordion>

      {isEditOpen && selectedForcast && (
        <div className="fixed inset-0 bg-black bg-opacity-80 z-50 flex items-center justify-center p-4 md:p-0">
          <WeatherForm
            data={selectedForcast}
            statusOptions={forcastOptions}
            closeModal={() => setSelectedForcast(undefined)}
            onConfirm={() => {
              setSelectedForcast(undefined);
              refetchTravelStatus();
            }}
            ownerId={ownerId}
          />
        </div>
      )}
    </>
  );
};

export default WeatherAndTravelStatus;
